/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBreadCrumbNameRequest
 */
export interface GetBreadCrumbNameRequest {
    /**
     * 
     * @type {string}
     * @memberof GetBreadCrumbNameRequest
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof GetBreadCrumbNameRequest
     */
    id: string;
}

export function GetBreadCrumbNameRequestFromJSON(json: any): GetBreadCrumbNameRequest {
    return GetBreadCrumbNameRequestFromJSONTyped(json, false);
}

export function GetBreadCrumbNameRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBreadCrumbNameRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'],
    };
}

export function GetBreadCrumbNameRequestToJSON(value?: GetBreadCrumbNameRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'id': value.id,
    };
}


